import { Box, Link, Stack, Typography } from "@mui/material";

const GoodsItem = ({ goods }) => {
  return (
    <Box sx={{ border: "1px solid #ccc", padding: 1, borderRadius: 1, marginTop: 1 }}>
      <Typography sx={{ fontSize: "0.9rem", fontWeight: "bold", color: "#009527" }} >{goods.GoodsName}</Typography>
      <Stack direction="row" justifyContent={"space-between"} sx={{ marginTop: 1 }}>
        <Typography sx={{ fontSize: "0.8rem" }}>{goods.GoodsSize}</Typography>
        <Link href={`/goods/${goods.GoodsID}`} rel="noopener">{">>>"}</Link>
      </Stack>
    </Box>
  );
}
export default GoodsItem;